<div class="descriptive-text">{{ label() }}</div>
@if (button()) {
  <orbit-button
    [icon]="icon()"
    [size]="'extra-small'"
    [rounded]="true"
    (click)="buttonClick.emit(true)" />
} @else {
  <orbit-fa-icon [iconName]="questionMark" class="info-icon" />
  @if (tooltip() !== '') {
    <div class="tooltip">
      <div class="tooltip-arrow"></div>
      <div class="tooltip-text">{{ tooltip() }}</div>
    </div>
  }
}
